import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getUserId = createSelector(
  (state: State) => state.findUser.userInfo,
  (userInfo): number => {
    // @ts-ignore
    if (userInfo.data) {
      // @ts-ignore
      return userInfo.data[0].user_id;
    } else {
      return null;
    }
  }
);

export default getUserId;
